// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".expand-enter-active,.expand-leave-active{overflow:hidden;transition:height .5s cubic-bezier(.83,0,.17,1)}@media(prefers-reduced-motion){.expand-enter-active,.expand-leave-active{transition:none!important}}.expand-enter,.expand-leave-to{height:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
